export default __webpack_public_path__ + "images/filter_arrow_down-a09e3955238ae214cdec7e3312988394.svg";